import { StatusEnum } from '../enums/enums'

// CAR-3872: an OPEN work order's pill shows how far calibration has got. The backend
// derives calibration_progress (NOT_STARTED / IN_PROGRESS / COMPLETED) from the three
// step flags; CLOSED and MOVED work orders keep their own status.
const CALIBRATION_PROGRESS_PILLS = {
  IN_PROGRESS: { label: 'In Progress', pill: 'bg-[#FEF3C7] text-[#92400E]', dot: 'bg-[#D97706]' },
  COMPLETED: { label: 'Completed', pill: 'bg-[#DCFCE7] text-[#166534]', dot: 'bg-[#16A34A]' }
}

const OPEN_PILL = { pill: 'bg-[#E8EFFF] text-[#2C3D4D]', dot: 'bg-[#2C3D4D]' }
const INACTIVE_PILL = { pill: 'bg-[#EBEDF0] text-[#6B7280]', dot: 'bg-[#6B7280]' }

/** The label and pill colours for a work order's Status. */
export const getWorkOrderStatusPill = (item) => {
  const status = StatusEnum[item?.status]
  if (status !== StatusEnum.OPEN) {
    return { label: status, ...INACTIVE_PILL }
  }
  return CALIBRATION_PROGRESS_PILLS[item?.calibration_progress] || { label: status, ...OPEN_PILL }
}
